<template>
    <div>

        <form class="form-horizontal" >

            <div class="form-group">
                <div class="col-sm-12">
                    <label class="control-label">NOME DO CLIENTE</label>
                    <input disabled type="text" v-model="contrato.cliente.nome" class="form-control" >
                </div>
            </div>

            <div class="panel panel-info">
                <div class="panel-heading">COMANDOS PERSONALIZADOS</div>
                <div class="panel-body" >

                    <div class="form-group">
                        <div class="col-sm-12">
                            <label for="inputIp" class="control-label">COMANDO A SER ENVIADO:</label>
                            <textarea rows="5" v-model="comando.comando" class="form-control" id="inputIp"></textarea>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="col-sm-10">
                            <button :disabled="!comando.comando" type="button" @click="send()" class="btn btn-success">ENVIAR COMANDO</button>
                        </div>
                    </div>

                </div>
            </div>

        </form>

        <list-comandos v-if="user.level <= 3" :id="contrato._id"></list-comandos>

    </div>
</template>
<script>
/* global swal */
import { Contratos } from "../../../class/contratos";
import contratoMixin from "../../mixins/contrato";

import { ListComandos } from "../../../components/exports";

export default {
    components: {
        ListComandos
    },
    mixins: [contratoMixin],
    data() {
        return {
            comando: {
                comando: null,
                contrato_id: null
            }
        };
    },
    methods: {
        send() {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Enviar Comando",
                    text: "Posso enviar o comando?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            this.comando.contrato_id = this.contrato._id;

                            Contratos.sendComando(this.comando)
                                .then(() => {
                                    this.$emit("comandos");
                                    this.comando.comando = null;
                                    resolve();
                                })
                                .catch(err => {
                                    if (err.status) {
                                        swal(
                                            "Roteador OFFLINE!",
                                            "Roteador não pinga!",
                                            "error"
                                        );
                                    }
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
